import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";
import { globalConfig } from "../../../config/config";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
// import { useContentObjectContext } from "../contexts/ContentObjectContext";
// const querystring = require("querystring");

const CreateContentTemplates = () => {
  const [templateTypes, setTemplateTypes] = useState([]);

	const token = globalConfig.hardcoded_header;
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentTemplateId: 0,
    contentId: 0, //currentContentObject,
    contentTemplateTypeId: 0,
    contentTemplateName: "",
    contentTemplateDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-templates`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-templates/contentTemplateId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentTemplateId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentTemplateId
          );
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({ ...state, contentTemplateName: "", contentTemplateDescr: "" });
    });
  }
  function handRest() {
    setState({ ...state, contentTemplateName: "", contentTemplateDescr: "" });
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-template-types`,
         apiHeader(token)
      )
      .then((res) => {
        const templateTypes = res.data;
        console.log(templateTypes);
        setTemplateTypes(templateTypes);
      })
      .catch((x) => {
      });
  };
  useEffect(() => {}, []);
  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Template</h4>			
			<Link to="/breeze/list-content-templates">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="contentId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Template Type">
            Template Type
          </label>
          <select
            id="contentTemplateTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentTemplateTypeId}
            onChange={handleChange}
          >
            {/* <option
              value={state.contentTemplateTypeSelectList}
              onChange={handleChange}
            /> */}
            <option>Select Template Type</option>
            {templateTypes.map(
              ({ contentTemplateTypeDescr, contentTemplateTypeId }) => (
                <option
                  key={contentTemplateTypeId}
                  value={contentTemplateTypeId}
                >
                  {contentTemplateTypeDescr}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Template Object">
            Template Object
          </label>
          <input
            id="contentTemplateName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentTemplateName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentTemplateDescr"
            className="form-control input-xlarge col-sm-8"
            cols="60"
            rows="5"
            value={state.contentTemplateDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handRest}>
          {" "}
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-success"
          value="Create"
          onClick={handleSubmit}
        >
          {" "}
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentTemplates;
